import styled from 'styled-components';

export const StoriesContainer = styled.div`
	display: flex;
	height: 100%;
	gap: 0;
	overflow: hidden;
`;

export const StoryList = styled.div`
	width: 280px;
	border-right: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[0]};
	overflow-y: auto;
	display: flex;
	flex-direction: column;
`;

export const StoryItem = styled.div<{ selected?: boolean; isBroken?: boolean }>`
	padding: 12px 16px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme, selected }) => (selected ? theme.gray[100] : theme.gray[0])};
	color: ${({ theme, selected }) => (selected ? theme.gray[1000] : theme.gray[800])};
	transition: background-color 0.2s ease, color 0.2s ease;
	font-size: 14px;
	font-weight: ${({ selected }) => (selected ? 500 : 400)};
	display: flex;
	align-items: center;
	gap: 8px;

	${({ isBroken, theme }: any) => (isBroken ? `border-left: 3px solid ${theme.red[500]};` : '')}

	&:hover {
		background-color: ${({ theme, selected }) => (selected ? theme.gray[100] : theme.gray[100])};
	}
`;

export const StoryItemTitle = styled.span`
	flex: 1;
`;

export const StoryItemBadge = styled.span`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.red[500]};
	opacity: 0.8;
`;

export const StoryIndex = styled.div`
	padding: 12px 16px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: ${({ theme }) => theme.gray[600]};
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[200]};
`;

export const StoryPreviewContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background-color: ${({ theme }) => theme.gray[0]};
`;

export const StoryPreviewFrame = styled.div`
	flex: 1;
	overflow: hidden;
	position: relative;
`;

export const EmptyState = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 14px;
`;

export const BrokenStoryContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	padding: 40px;
	text-align: center;
`;

export const BrokenStoryIcon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
`;

export const BrokenStoryTitle = styled.div`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 12px;
`;

export const BrokenStoryMessage = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[700]};
	margin-bottom: 24px;
	line-height: 1.5;
	max-width: 500px;
`;

export const BrokenStoryCode = styled.div`
	width: 100%;
	max-width: 600px;
	max-height: 300px;
	overflow: auto;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	padding: 16px;
	text-align: left;

	pre {
		margin: 0;
		font-size: 12px;
		font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
		color: ${({ theme }) => theme.gray[800]};
		white-space: pre-wrap;
		word-break: break-word;
	}
`;
